/**
 * Riders Corner Search Component
 *
 * Single Responsibility: Handles search input and submission
 * Interface Segregation: Only exposes necessary props
 */

import React, { FormEvent } from 'react';
import {
  typographyColors,
  backgroundColors,
  brandColors,
} from '@/design-system/utils';

interface RidersCornerSearchProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function RidersCornerSearch({
  value,
  onChange,
  onSubmit,
  placeholder = 'Riyadh 5 day trip',
  className = '',
}: RidersCornerSearchProps) {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(value);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`flex items-center gap-2 ${className}`}
      style={{
        width: '100%',
        maxWidth: '600px',
      }}
    >
      <input
        type='text'
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        className='flex-1 rounded-lg border px-4 py-3 text-base'
        style={{
          backgroundColor: backgroundColors.primary,
          borderColor: '#e7e5e4',
          color: typographyColors.primary,
          outline: 'none',
        }}
      />
      <button
        type='submit'
        className='flex items-center justify-center rounded-lg p-3'
        style={{
          backgroundColor: brandColors.secondary,
          minWidth: '48px',
          minHeight: '48px',
        }}
      >
        <svg
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z'
            stroke={typographyColors.primary}
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M19 19L14.65 14.65'
            stroke={typographyColors.primary}
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </button>
    </form>
  );
}
